import SwiperImageOne from '../assets/img/Swiper/Slider-1.jpg';
import SwiperImageTwo from '../assets/img/Swiper/Slider-2.jpg';
import SwiperImageThree from '../assets/img/Swiper/Slider-3.jpg';
import SwiperImageFour from '../assets/img/Swiper/Slider-4.jpg';
import SwiperImageFive from '../assets/img/Swiper/Slider-5.jpg';

const DataSwiper = [
    {
        id: 1,
        image: SwiperImageOne,
        title: 'STUCK + FASSADEN',
        text: 'Die Außenseite des Hauses wird nach Ihren Wünschen mit Stuck oder mit Putz verarbeitet. Das erste Erscheinungsbild eines Gebäudes ist am wichtigsten.'
    },
    {
        id: 2,
        image: SwiperImageTwo,
        title: 'TROCKENBAU',
        text: 'Wir können Ihren Raum mit Trockenbautechnik nach Ihren Wünschen aufteilen. Fast sämtliche Anforderungen an den Brand -, Wärme - und Schallschutz kann man mit Trockenbau, sofern man diese nach den technischen Vorschriften einbaut, erfüllen.'
    },
    {
        id: 3,
        image: SwiperImageThree,
        title: 'AKUSTIKDECKEN',
        text: 'Akustikdecken kombinieren hohe Schall-Längsdämmung mit hohen Absorptionswerten und das bei den oft gewünschten glatten Oberflächen.'
    },
    {
        id: 4,
        image: SwiperImageFour,
        title: 'FLIESENARBEITEN',
        text: 'Wir verlegen mit viel Liebe zum Detail fachgerecht Fliesen im Innenbereich und Außenbereich und übernehmen jegliche Untergrundarbeiten und Vorbereitungsarbeiten.'
    },
    {
        id: 5,
        image: SwiperImageFive,
        title: 'PERGOLA',
        text: 'VESKOVIC PERGOLA ist eine Pergola-Produktionsfirma, die gegründet wurde, um Lebensräume im Freien zu schaffen.'
    }
]

export default DataSwiper